'use client';

import { CATEGORY_IDS } from '@wwe-portal/web/utils/constants/offer';
import { useEffect, useMemo, useState } from 'react';
import { StoreRevampNavigation } from '@wwe-portal/widget/store-revamp';
import { useNavigationState } from '@wwe-portal/web/hooks/offer/category-navigation-state';
import {
  CashPacksIcon,
  DailyIcon,
  FeaturedIcon,
  RewardFilledIcon,
  RubiesIcon,
  WebCoinIcon,
} from '@wwe-portal/ui/components/icons';
import { useSendSectionViewed } from './use-send-section-viewed';
import { OfferData } from '@wwe-portal/entities/offer.type';

const itemIds = [
  {
    id: CATEGORY_IDS.FEATURED,
    label: 'Featured',
    icon: <FeaturedIcon className="size-4" />,
  },
  {
    id: CATEGORY_IDS.DAILY,
    label: 'Daily',
    icon: <DailyIcon className="size-4" />,
  },
  {
    id: CATEGORY_IDS.RUBIES,
    label: 'Rubies',
    icon: <RubiesIcon className="size-4" />,
  },
  {
    id: CATEGORY_IDS.CASH_PACKS,
    label: 'Cash Packs',
    icon: <CashPacksIcon className="size-4" />,
  },
  {
    id: CATEGORY_IDS.REWARDS,
    label: 'Rewards',
    icon: <RewardFilledIcon className="size-4" />,
  },
  {
    id: CATEGORY_IDS.WEBCOINS,
    label: 'Web Coins',
    icon: <WebCoinIcon className="size-4" />,
  },
];

export const CategoryNavigation = ({
  availableItems,
  offerMap,
}: {
  availableItems: string[];
  offerMap: Map<string, OfferData>;
}) => {
  const [lockedActiveId, setLockedActiveId] = useState<string | undefined>(
    undefined
  );
  // Analytics hooks
  const activeId = useNavigationState((state) => state.activeId);

  const displayedItems = useMemo(
    () => itemIds.filter((item) => availableItems.includes(item.id)),
    [availableItems]
  );
  useEffect(() => {
    const clearLock = () => {
      setLockedActiveId(undefined);
    };
    window.addEventListener('wheel', clearLock);
    window.addEventListener('touchmove', clearLock);
    return () => {
      window.removeEventListener('wheel', clearLock);
      window.removeEventListener('touchmove', clearLock);
    };
  }, [activeId]);

  useSendSectionViewed(offerMap);

  return (
    <StoreRevampNavigation
      activeId={lockedActiveId ?? activeId}
      itemIds={displayedItems}
      onClick={({ id }) => {
        useNavigationState.getState().setActiveId(id);
        setLockedActiveId(id);
      }}
    />
  );
};
